module.exports = __webpack_public_path__ + "static/media/don_car-full.bfdc6a95.png";